import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPlectrum = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 35,
	height: 32,
	viewBox: "0 0 35 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M30.5875 6.13907C24.8785 2.80161 12.9914 0.178834 6.6982 0.00882481C0.40334 -0.161185 -0.299335 2.11992 0.0852695 7.31263C0.471497 12.507 1.94338 20.6113 5.19223 25.7876C8.43947 30.9638 13.4621 33.2119 18.7865 31.3566C24.1093 29.4997 29.7356 23.5395 32.7816 18.5333C35.8276 13.5304 36.2966 9.47654 30.5875 6.13907ZM19.4113 20.4017H15.4078V27.174H11.3313V12.1076H15.4078V16.2538H19.4113V16.2423C21.0909 16.2126 22.4443 14.8211 22.4443 13.1062C22.4443 11.3912 21.0909 9.99813 19.4113 9.97007V9.96677H6.23408L7.72382 5.82051H19.4096C23.3758 5.82051 26.5922 9.09196 26.5922 13.126C26.5938 17.1616 23.3774 20.4017 19.4113 20.4017Z",
		fill: "#0064FA"
	})
});
export default SvgPlectrum;
